import { type Organization } from '@/types/Organization'

/**
 * Creates a new Organization with default values
 */
export function createOrganization(data: Partial<Organization> = {}): Organization {
  const now = new Date()

  return {
    name: data.name ?? '',
    type: data.type ?? 'supplier',
    status: data.status ?? 'lead',

    // Contact information
    email: data.email,
    phone: data.phone,
    fax: data.fax,
    website: data.website,

    // Address
    address: data.address,
    streetAddress: data.streetAddress,
    city: data.city,
    state: data.state,
    zipCode: data.zipCode,
    postalCode: data.postalCode,
    country: data.country ?? 'USA',

    // Fiscal information
    taxId: data.taxId,
    accountNumber: data.accountNumber,
    sales: data.sales,
    assets: data.assets,
    employees: data.employees,

    // CRM fields
    contacts: data.contacts ?? [],
    notes: data.notes,
    lastContactedAt: data.lastContactedAt,
    nextFollowUpDate: data.nextFollowUpDate,
    tags: data.tags ?? [],
    assignedTo: data.assignedTo,
    source: data.source,
    description: data.description,
    engagementStage: data.engagementStage,
    industry: data.industry,
    size: data.size,

    // Search fields
    name_lower: data.name_lower ?? (data.name ?? '').toLowerCase(),

    // Metadata
    createdAt: data.createdAt ?? now,
    updatedAt: data.updatedAt ?? now,
    createdBy: data.createdBy,
    updatedBy: data.updatedBy,
    isDeleted: data.isDeleted ?? false,
  }
}
